import { z } from 'zod';

import { zodTemporalInstant } from '../Temporal';
import { BaseLoanEvent } from './BaseLoanEvent';

/**
 * @description This event is used to trigger the principal late automation.
 *  @param type - The type of event.
 *  @param tickTime - The scheduled time for the automation. Used to determine which statement the principal late fee is applied to
 * (ex. if tickTime is 2025-01-15, the principal late fee will be applied to the January statement).
 */
export const PrincipalLateAutomationEvent = BaseLoanEvent.extend({
  type: z.literal('principalLateAutomation'),
  eventTime: zodTemporalInstant, // override BaseLoanEvent to make this required because this is needed for the ticking service
});
export type PrincipalLateAutomationEvent = z.infer<typeof PrincipalLateAutomationEvent>;
